<div>
    <div class='modal-header'>
        <h5 class='modal-title' id='modal-basic-title'>{{data.subject}}</h5>
        <button type='button' class='btn-close' aria-label='Close' (click)='activeModal.dismiss()'>
          </button>
    </div>
    <div class='modal-body'>
        <ng-container *ngIf="!userData.isBusy; then gridTemplate else loading"></ng-container>   
    </div>
    <div class='modal-footer'>
      <button ejs-button id="btnCancel" name="cancel"
              (click)="this.activeModal.close(false);">
        Cancel
      </button>
      <button ejs-button cssClass="e-primary" id="btnResend" name="resend"
              [disabled]="!failedAnnouncement" (click)="resubmitUserAnnouncement(); this.activeModal.close(true);">
        Resend
      </button>
    </div>
</div>

<ng-template #gridTemplate>
    <ejs-grid #grid [dataSource]="userData.data" [pageSettings]="pagerSettings" [allowPaging]="userData.paging"
        [allowSorting]="true" (actionBegin)="actionBegin($event)" (dataBound)='grdUserListDataBound()'>
        <e-columns>
            <e-column field="firstName" headerText="First Name" width="40"></e-column>
            <e-column field="lastName" headerText="Last Name" width="70"></e-column>
            <e-column field="email" headerText="Email" width="90"></e-column>
            <e-column field="groupName" headerText="Role" width="50"></e-column>
            <e-column field="receiptStatus" headerText="Status" width="30"></e-column>
            <e-column field="datetimeSent" headerText="Date Sent (UTC)" width="70">
                <ng-template #template let-data>
                    {{data.datetimeSent | dateFormat}}
                </ng-template>
            </e-column>
        </e-columns>
    </ejs-grid>
</ng-template>

<ng-template #loading>
    <p class="center-text d-flex justify-content-center"><em class="spinner-border text-primary" aria-hidden="true"></em></p>  
</ng-template>
